import { useQuery } from '@tanstack/react-query';
import Axios from 'axios';

import backendService from '../services/backendService';

export const useGameMediaFile = (fileId?: string, isAuthenticated?: boolean) => {
  const { data, isFetching, error } = useQuery<string | undefined, string>(
    ['game-file', fileId],
    async () => {
      if (!fileId) return Promise.resolve(undefined);
      try {
        let downloadRes;
        if (isAuthenticated === false) {
          downloadRes = await backendService.instance.getPublicDownloadUrl(`${fileId}`);
        } else {
          downloadRes = await backendService.instance.getDownloadUrl(`${fileId}`);
        }
        const url = downloadRes.data.url;
        const res = await Axios.request<Blob>({
          method: 'get',
          url,
          responseType: 'blob',
        });
        const objUrl = URL.createObjectURL(res.data);
        return objUrl;
      } catch (e) {
        return undefined;
      }
    },
    {
      enabled: !!fileId,
      staleTime: 1000 * 60 * 5,
    },
  );

  return {
    data,
    isLoading: isFetching,
    error,
  };
};
